module.exports = __webpack_public_path__ + "assets/img/icon-cdp.be46532e.png";